import Img1 from "../assets/slide/Cuadro-foto-1.png";
import Img2 from "../assets/slide/Cuadro-foto-2.png";
import Img3 from "../assets/slide/Cuadro-foto-3.png";
import Img4 from "../assets/slide/Cuadro-foto-4.png";
import Img5 from "../assets/slide/Cuadro-foto-5.png";

import Icon1 from "../assets/slide/Icono-item-1-06.svg";
import Icon2 from "../assets/slide/Icono-item-1-07.svg";
import Icon3 from "../assets/slide/Icono-item-1-08.svg";
import Icon4 from "../assets/slide/Icono-item-1-09.svg";
import Icon5 from "../assets/slide/Icono-item-1-10.svg";

export const ListServices = [
  {
    // titulo: "Solicita tus noches",
    texto:
      "Podrás beneficiarte del programa de redención de noches de alojamiento en hoteles de propiedad y operados por On Vacation.",
    icon: Icon1,
    scrollToSection: "nights",
    image: Img1,
  },
  {
    // titulo: "Elite Privilege",
    texto:
      "Nuestros afiliados disfrutan de acceso las 24/7 para gestionar reservas con tarifas económicas y diferenciadas del mercado. Ofrecemos pagos automáticos y asistencia personalizada de nuestros asesores de viajes.",
    icon: Icon2,
    image: Img2,
  },
  {
    // titulo: "Hoteles",
    texto:
      "¡Bienvenidos al Paraíso: Hoteles de Ensueño para Tus Viajes Inolvidables! Desde vistas panorámicas hasta experiencias culinarias excepcionales, cada hotel que ofrecemos está diseñado para satisfacer tus más altas expectativas de viaje.",
    icon: Icon3,
    image: Img3,
  },
  {
    // titulo: "Vuelos",
    texto:
      "Prepárate para despegar hacia tus sueños con nuestros servicios de vuelos. Encontrarás una amplia gama de opciones que se adaptan a tus necesidades, desde vuelos económicos hasta experiencias de lujo. Nuestro equipo de expertos está aquí para ayudarte a planificar tu próximo viaje.",
    icon: Icon4,
    image: Img4,
  },
  {
    // titulo: "Traslados",
    texto:
      "Descubre la comodidad y la tranquilidad de viajar con nuestro servicio de traslados de primera clase. Desde el momento en que aterrizas en el aeropuerto hasta que finaliza tu gran aventura, nos encargamos de todos los detalles para que tu viaje sea sin preocupaciones.",
    icon: Icon5,
    image: Img5,
  },
];
